import React from 'react';

import {Button, Dialogue, Modal} from '@albert-io/atomic';
import JoinClassroomForm from './JoinClassroomForm';
import JoinClassroomInput from './JoinClassroomInput';
import JoinClassroomSubmitButton from './JoinClassroomSubmitButton';

interface Props {
  handleClose: () => void;
  isNewStudentDashboard?: boolean;
  onEnrollSuccess?: () => void;
}

export default function JoinClassroomModal({
  handleClose,
  isNewStudentDashboard = false,
  onEnrollSuccess
}: Props) {
  return (
    <Modal ariaLabel='Join a class' dismissable handleClose={handleClose}>
      {({CloseButtonWrapper, modalContentStyle}) => (
        <Dialogue className={modalContentStyle} hideCloseBtn inModal>
          <JoinClassroomForm
            isNewStudentDashboard={isNewStudentDashboard}
            onEnrollSuccess={onEnrollSuccess}
          >
            <Dialogue.Body className='flex flex-col'>
              <JoinClassroomInput />
            </Dialogue.Body>
            <div className='mt-x5 flex justify-end gap-x1'>
              <CloseButtonWrapper>
                <Button color='secondary'>Cancel</Button>
              </CloseButtonWrapper>
              <JoinClassroomSubmitButton />
            </div>
          </JoinClassroomForm>
        </Dialogue>
      )}
    </Modal>
  );
}
